export default "__VITE_ASSET__lSex8WDd7oI0k1CxMrZ2IA__"